<template lang="pug">
#cars-exportacao-tabela
    .tabela-relatorio-exportacao
        el-table(
            :key="listagemTableKey('cars', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            ref='cars-exportacao-table',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "dataAverbacao", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
        )
            el-table-column(
                prop='codigo',
                :label='$t("relatorioExportacao.detalhe.numeroCar")',
                align='left',
            )
                template(slot-scope='scope')
                    | {{ scope.row.codigo || '-' }}

            el-table-column(
                prop='documento',
                :label='$t("relatorioExportacao.detalhe.documento")',
                align='left',
                width='250',
                sortable
            )
                template(slot-scope='scope')
                    | {{ scope.row.documento || '-' }}

            el-table-column(
                prop='numeroContrato',
                :label='$t("relatorioExportacao.detalhe.numeroContrato")',
                align='left',
                width='250',
                sortable
            )
                template(slot-scope='scope')
                    | {{ scope.row.numeroContrato || '-' }}

            el-table-column(
                prop='elegibilidade',
                :label='$t("relatorioExportacao.detalhe.analise")',
                align='left',
                width='250',
                sortable
            )
                template(slot-scope='scope')
                    .status-elegibilidade(:class='obterStatus(scope.row.elegibilidade).class')
                        i(:class='obterStatus(scope.row.elegibilidade).icon')
                        span {{ obterStatus(scope.row.elegibilidade).status }}

            el-table-column(
                prop='dataUltimaAnalisa',
                :label='$t("relatorioExportacao.detalhe.dataUltimaAnalise")',
                align='left',
                width='250',
                sortable
            )
                template(slot-scope='scope')
                    | {{ formatarData(scope.row.dataUltimaAnalisa) }}

            el-table-column(
                :label='$t("relatorioExportacao.detalhe.acoes")',
                align='center',
                width='100'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-download',
                                :disabled='!scope.row.relatorioPronto',
                                @click.native='exportarRelatorioCar(scope.row)'
                            )
                                | {{ $t('relatorioExportacao.lista.download') }}

            template(slot='empty')
                el-empty(:description='$t("relatorioExportacao.lista.listaVazia")')

    .tabela-relatorio-exportacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('relatorioExportacao.lista.listaVazia') : $t('relatorioExportacao.lista.listaVazia') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import services from '@/modules/relatorio-exportacao/services/RelatorioService';
import { obterStatus } from '@/modules/relatorio-exportacao/utils/assets';
import { formatarData } from '@/modules/relatorio-exportacao/utils';

export default {
    name: 'CARsTabela',
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        relatorio: {
            type: Object | null,
            required: true
        }
    },
    methods: {
        obterStatus,
        formatarData,
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        visualizarDetalhe(row) {
            this.$router.push({
                name: 'RelatorioExportacaoDetalhe',
                params: {
                    id: row.id
                }
            });
        },
        async exportarRelatorioCar(row) {
            try {
                const params = {
                    idNavio: this.relatorio.id,
                    idCar: row.id
                };

                await services.downloadRelatorioCar(params);
                this.$notify.success({
                    message: this.$t('relatorioExportacao.lista.downloadSucesso')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('relatorioExportacao.lista.downloadErro')
                });
            }
        }
    }
};
</script>
<style lang="scss">
#cars-exportacao-tabela {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .status-elegibilidade {
        display: flex;
        align-items: center;
        gap: 2px;

        i {
            font-size: 20px;
        }

        &.status-amarelo {
            color: #bfae19;
            font-weight: 500;
        }

        &.status-laranja {
            color: var(--warning);
            font-weight: 500;
        }

        &.status-danger {
            color: var(--danger);
            font-weight: 500;
        }

        &.status-sucess {
            color: var(--green);
            font-weight: 500;
        }

        &.default {
            color: var(--gray);
            font-weight: 500;
        }
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-relatorio-exportacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
